export default __webpack_public_path__ + "static/media/donation3.0990bc92.png";